import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { IntroStory } from './components/IntroStory';
import { MasterMap } from './components/MasterMap';
import { Introducing } from './components/Introducing';
import { ProblemSection } from './components/ProblemSection';
import { BeforeAfter } from './components/BeforeAfter';
import { Situations } from './components/Situations';
import { Volumes } from './components/Volumes';
import { Toolkit } from './components/Toolkit';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { LookFor } from './components/LookFor';
import { Creator } from './components/Creator';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="relative min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3mkhlbqxmcy4g">
      <MetaPixel data-id="element-1" data-mp="3rdaqgfx028h2" />
      <Hero data-id="element-2" data-mp="3rcsxpt9jqcdw" />
      <main data-id="element-3" data-mp="3rd19fhtxnbni">
        <IntroStory data-id="element-4" data-mp="3reltuemj9e7n" />
        <MasterMap data-id="element-5" data-mp="5ott78p769p" />
        <Introducing data-id="element-6" data-mp="6817u0q2c9h" />
        <ProblemSection data-id="element-7" data-mp="4n7u7q58zd7" />
        <BeforeAfter data-id="element-8" data-mp="82jf0klzq9v" />
        <Situations data-id="element-9" data-mp="2zld1d7i6tbah" />
        <Volumes data-id="element-10" data-mp="2zlv6yuqqp1v2" />
        <Toolkit data-id="element-11" data-mp="2zmeoiach9o8k" />
        <Bonuses data-id="element-12" data-mp="2zmwit1fkxsdu" />
        <Testimonials data-id="element-13" data-mp="2zng0ch1bierc" />
        <Offer data-id="element-14" data-mp="33mf623uvifju" />
        <Guarantee data-id="element-15" data-mp="33lx02fiesmyq" />
        <LookFor data-id="element-16" data-mp="33nghwajpr62m" />
        <Creator data-id="element-17" data-mp="33myix65o2dr0" />
        <FAQ data-id="element-18" data-mp="33ohzyyz5cstu" />
        <FinalCTA data-id="element-19" data-mp="38m1elzzrb7mb" />
      </main>
      <Footer data-id="element-20" data-mp="38kqau06b9zv7" />
      <FloatingCTA data-id="element-21" data-mp="38k6v8q44vnkc" />
      <PurchasePopup data-id="element-22" data-mp="38nupjrheke04" />
    </div>;
}